export default "__VITE_PUBLIC_ASSET__3d95da7b__"